// v83 — the owner's demo blur, one shared state for every page. v85 — a plain on/off: on = every creator blurred.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { resetGems } from "@/components/c360/GemMark";

const S = { email: "", state: null, p: null, subs: new Set() };

export function setDemoBlur(b) {
  if (!b) return;
  S.state = { on: !!b.on };
  S.subs.forEach((fn) => fn(S.state));
}

// After any change: every page and the gem marks follow.
export function changedDemoBlur(b) {
  setDemoBlur(b);
  resetGems();
}

export async function toggleDemoBlur() {
  if (!S.state) return;
  const { data } = await api.put("/creator360/blur", { on: !S.state.on });
  changedDemoBlur(data);
}

export function useDemoBlur() {
  const { user } = useAuth();
  const email = user?.is_super_admin ? user.email : "";
  const [b, setB] = useState(() => (email && S.email === email ? S.state : null));
  useEffect(() => {
    if (!email) { setB(null); return undefined; }
    S.subs.add(setB);
    if (S.email !== email) { S.email = email; S.state = null; S.p = null; }
    if (S.state) setB(S.state);
    else if (!S.p) S.p = api.get("/creator360/blur").then((r) => setDemoBlur(r.data)).catch(() => {});
    return () => { S.subs.delete(setB); };
  }, [email]);
  return { blur: b, isBlurred: () => !!b?.on };
}

// Everything that identifies a creator: tagged names/titles, profile and social links, YouTube images.
export const BLUR_TARGETS = [
  "[data-blur-id]", ".db-t", "a[href^=\"/kol/\"]", "a[href^=\"/unaffiliated/\"]", "a[href^=\"/live-streaming-intel/\"]",
  "a[href^=\"/x-creators/\"]", "a[href^=\"/my-radar/creator/\"]", "a[href*=\"youtube.com\"]", "a[href*=\"youtu.be\"]",
  "a[href*=\"t.me/\"]", "a[href*=\"instagram.com\"]", "a[href*=\"x.com/\"]", "a[href*=\"twitter.com/\"]",
  "img[src*=\"ggpht.com\"]", "img[src*=\"ytimg.com\"]", "img[src*=\"yt3.\"]",
].join(", ");

export const BLUR_CSS = `:is(${BLUR_TARGETS}):not([data-blur-skip]):not([data-blur-skip] *){filter:blur(6px);user-select:none;}`;
